import { Config } from "../../../_config/index.js"
import { AuthPayload } from "../../Models/AuthPayload.js"
import type { LocalAuthRepository, SaveAuthPayloadLocalAuthRepositoryInput } from "../LocalAuthRepository.js"

export const AUTH_PAYLOAD_KEY = "auth_payload"

export class LocalStorageAuthRepository implements LocalAuthRepository {
  static create(config: Config) {
    void config
    return new LocalStorageAuthRepository()
  }

  async saveAuthPayload({ payload }: SaveAuthPayloadLocalAuthRepositoryInput) {
    try {
      const serialized = payload.serialize()
      localStorage.setItem(AUTH_PAYLOAD_KEY, JSON.stringify(serialized))
    } catch (error) {
      throw new Error(`Failed to save auth payload: ${error}`)
    }
  }

  async getAuthPayload() {
    try {
      const item = localStorage.getItem(AUTH_PAYLOAD_KEY)
      if (!item) return null

      const parsed = JSON.parse(item)
      return AuthPayload.create(parsed)
    } catch (error) {
      console.warn(`Error reading auth payload:`, error)
      return null
    }
  }

  async clearAuthPayload() {
    try {
      localStorage.removeItem(AUTH_PAYLOAD_KEY)
    } catch (error) {
      throw new Error(`Failed to clear auth payload: ${error}`)
    }
  }
}
